import { combineReducers } from 'redux'

// Actions
export * as announcements from './api/announcements'
export * as awards from './api/awards'
export * as awardUnits from './api/award-units'
export * as organizations from './api/organizations'
export * as blob from './api/blob'
export * as codeLists from './api/code-lists'
export * as common from './api/common'
export * as dashboard from './api/combineDashboard'
export * as emails from './api/emails'
export * as leaders from './api/leaders'
export * as locales from './api/locales'
export * as nextLevel from './api/nextLevel'
export * as participants from './api/participants'
export * as registrations from './api/registrations'
export * as passwords from './api/passwords'
export * as payment from './api/payment'
export * as assessor from './api/assessor/'
export * as badges from './api/badges'
export * as actions from './api/actions'
export * as lists from './api/lists'
export * as accessVerification from './api/accessVerification'

// Reducers
/* eslint-disable */
import announcements from './api/announcements'
import awards from './api/awards'
import awardUnits from './api/award-units'
import organizations from './api/organizations'
import assessor from './api/assessor/'
import blob from './api/blob'
import codeLists from './api/code-lists'
import common from './api/common'
import dashboard from './api/combineDashboard'
import emails from './api/emails'
import leaders from './api/leaders'
import locales from './api/locales'
import nextLevel from './api/nextLevel'
import participants from './api/participants'
import registrations from './api/registrations'
import passwords from './api/passwords'
import payment from './api/payment'
import badges from './api/badges'
import actions from './api/actions'
import lists from './api/lists'
import accessVerification from './api/accessVerification'
/* eslint-enable */

export default combineReducers({
  announcements,
  awards,
  awardUnits,
  organizations,
  assessor,
  blob,
  codeLists,
  common,
  dashboard,
  emails,
  leaders,
  locales,
  nextLevel,
  participants,
  registrations,
  passwords,
  payment,
  badges,
  actions,
  lists,
  accessVerification
})
